import { getEnvSettings } from '../configurationServices'
import { getFingerprint } from 'src/utils/fingerprint'
import {
  LocationLineCheckRequest,
  LocationLineCheckResponse,
  LocationLineCheckError,
} from './types'

const { REACT_APP_PB_API_TICKET_INQUIRY_BASE_URL, OIDC_STORAGE_KEY } = getEnvSettings()

interface OidcUser {
  access_token: string
  token_type: string
  expires_at: number
}

/**
 * Gets the stored token from session storage using OIDC key
 */
const getStoredToken = (): string | null => {
  try {
    const storedData = sessionStorage.getItem(OIDC_STORAGE_KEY)

    if (!storedData) {
      console.error('getStoredToken - No OIDC data found in session storage')
      return null
    }

    const oidcUser: OidcUser = JSON.parse(storedData)
    return oidcUser?.access_token || null
  } catch (error) {
    console.error('getStoredToken - Error parsing OIDC data:', error)
    return null
  }
}

/**
 * Fetches the location line check data
 * @param adminUserId - The admin user ID (UUID)
 * @returns Promise with the list of locations
 */
export const fetchLocationLineCheck = async (
  adminUserId: string,
): Promise<LocationLineCheckResponse> => {
  const token = getStoredToken()

  if (!token) {
    throw new LocationLineCheckError('Token no encontrado en session storage', 'AUTH_ERROR')
  }

  const fingerprint = await getFingerprint()

  const requestBody: LocationLineCheckRequest = {
    fingerprint: 'admin',
  }

  const response = await fetch(
    `${REACT_APP_PB_API_TICKET_INQUIRY_BASE_URL}/search/locationlineCheck/87895-LI78S`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'x-admin-user': adminUserId,
        'X-fingerprint': fingerprint,
        Origin: 'https://admin.placebet.com.do',
      },
      body: JSON.stringify(requestBody),
    },
  )

  let responseData: LocationLineCheckResponse

  try {
    responseData = await response.json()
  } catch {
    throw new LocationLineCheckError(
      `No se pudo procesar la respuesta del servidor: ${response.status} ${response.statusText}`,
      response.ok ? 'UNKNOWN' : `${response.status}`,
    )
  }

  // Check if response is ok
  if (!response.ok) {
    throw new LocationLineCheckError(
      `Error al obtener las ubicaciones (${response.status})`,
      `${response.status}`,
    )
  }

  // Validate response data structure
  if (!responseData.data || !Array.isArray(responseData.data)) {
    throw new LocationLineCheckError('Respuesta del servidor inválida', 'INVALID_RESPONSE')
  }

  return responseData
}
